import {
  Heading,
  IconCheck,
  LayoutVerticalSpacer,
  useMediumFromMediaQuery,
} from '@madpaws/design-system';
import DOMPurify from 'isomorphic-dompurify';
import React from 'react';

import { Card } from '~/components/pages/SearchResults/Card/Card';

import styles from './DefaultDynamicSeoFooterContent.module.css';

type Props = {
  contentList: string[];
  header: string;
  heading: string;
};

export const DefaultDynamicSeoFooterContent = ({
  contentList,
  heading,
  header,
}: Props): React.ReactElement => {
  const isMediumFromViewport = useMediumFromMediaQuery();
  const cleanContentList = contentList.filter(
    (value) => typeof value === 'string' && value.trim() !== ''
  );

  return (
    /* eslint-disable react/no-danger */
    <Card>
      <LayoutVerticalSpacer space="large1x">
        <Heading size={isMediumFromViewport ? 'small2x' : 'small3x'}>{heading}</Heading>
      </LayoutVerticalSpacer>
      <div
        className={styles.body}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(header) }}
      />
      {/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
      <ul className={styles.benefits} role="list">
        {cleanContentList.map((item, key) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={`content-${key}`}>
            <IconCheck size="medium" />
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item) }} />
          </li>
        ))}
      </ul>
    </Card>
    /* eslint-enable react/no-danger */
  );
};
